import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManufacturingHeroComponent } from '../../Components/Manufacturing/manufacturing-hero/manufacturing-hero';
import { ManufacturingOverviewComponent } from '../../Components/Manufacturing/manufacturing-overview/manufacturing-overview';
import { ManufacturingFeaturesComponent } from '../../Components/Manufacturing/manufacturing-features/manufacturing-features';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-manufacturing-page',
  standalone: true,
  imports: [CommonModule, ManufacturingHeroComponent, ManufacturingOverviewComponent, ManufacturingFeaturesComponent],
  templateUrl: './manufacturing-page.html',
  styleUrls: ['./manufacturing-page.css'],
})
export class ManufacturingPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Manufacturing Management Software',
      description:
        'Work centers, labor rates, standard costs, overhead rules, material planning, capacity load, quality inspections, and subcontract orders — orderYaa Manufacturing keeps production planned, costed, and on schedule.',
      path: '/manufacturing',
    });
  }
}
